import { cloneDeep, isArray, isEmpty } from "lodash";
import { CHANGE_CALENDAR, CHANGE_CONTAINER_SELECTED_TAB, RENDER_MESSAGE_TYPE_CONTAINER, RESET_CONTAINER_FIELDS } from "../../constants";
import { MessageTypeConstants } from "../../../services/bot/Message";


export const handleMessageTypeContainer = (conversationId, message) => (dispatch, getState) => {
    const tabStack = getState().tabStack;

    if (tabStack && !isEmpty(tabStack)) {
        const tabStackData = tabStack[conversationId];

        if (tabStackData && !isEmpty(tabStackData) && !isEmpty(tabStackData.components)) {
            handleExistingStack(dispatch, conversationId, tabStackData, message);
        } else {
            handleNewConversation(dispatch, conversationId, message);
        }
    } else {
        handleNewConversation(dispatch, conversationId, message);
    }
};


const handleExistingStack = (dispatch, conversationId, nonConversationalData, message) => {
    const updatedComponents = createUpdatedComponents(nonConversationalData, message);

    const updatedNonConversationalData = {
        ...nonConversationalData,
        components: updatedComponents,
    };

    const updateInBackground = message.options && message.options.updateInBackground;
    if (!updateInBackground) {
        updatedNonConversationalData.selectedTab = message.options.tabId;
    }

    dispatchMessageTypeContainer(
        dispatch,
        conversationId,
        updatedNonConversationalData
    );
};


const dispatchMessageTypeContainer = (dispatch, conversationId, data) => {
    dispatch({
        type: RENDER_MESSAGE_TYPE_CONTAINER,
        data: { [conversationId]: data },
    });
};


const handleNewConversation = (dispatch, conversationId, message) => {
    const updateInBackground = message.options && message.options.updateInBackground || "";
    const data = { components: [message] };

    if (!updateInBackground) {
        data.selectedTab = message.options.tabId;
    }

    data.containerSelectedTabIndex = 0;

    dispatchMessageTypeContainer(dispatch, conversationId, data);
};

const createUpdatedComponents = (tabStackData, message) => {
    let componentsList = [];
    let found = false;

    const updatedComponents = tabStackData.components.map((item) => {
        componentsList.push(item.options.tabId);
        const itemTabId = item.options && item.options.tabId;
        const messageTabId = message?.options && message?.options.tabId;

        if (itemTabId === messageTabId) {
            found = true;

            const updatedMessages = updateMessageStyle(message?.message, item);
            const getCurrentBreadcrumbTab = getCurrentActiveBreadcrumb(updatedMessages);

            const selectedBreadcrumbTabId = getCurrentBreadcrumbTab?.message?.options?.tabId || null;

            const updatedMessage = {
                ...message,
                message: updatedMessages,
                containerSelectedTabIndex: item.containerSelectedTabIndex || 0,
                selectedBreadcrumbTabId,
            };
            return updatedMessage;
        }
        return item;
    });

    if (!found) {
        updatedComponents.push({
            ...message,
            containerSelectedTabIndex:
                tabStackData.containerSelectedTabIndex || 0,
        });
    }

    return updatedComponents;
};

const updateMessageStyle = (message, item) => {
    return message.map((msg, index) => {
        const newMessage = { ...msg };
        if( newMessage?.message?.options?.style){
            newMessage.message.options.style = item?.message[index]?.message?.options.style;
        }
        return newMessage;
    });
};

const getCurrentActiveBreadcrumb = (message) => {
    if (isArray(message) && message.length > 0) {
        return message[message.length - 1];
    }
    return null;
};

export const handleCalendarChange = (conversationId, options, field, value, parentTabId) => (dispatch, getState) => {
    const tabStack = getState().tabStack;

    if (!isEmpty(tabStack)) {
        const tabStackData = tabStack[conversationId];

        if (tabStackData?.components) {
            const updatedComponents = tabStackData.components.map((item) => {
                if (item?.options?.tabId === options?.tabId) {
                    return {
                        ...item,
                        options: {
                            ...item.options,
                            [field]: value,
                        },
                    };
                }

                if (parentTabId === item?.options?.tabId) {
                    const updatedMessage = item.message.map((itm) => {
                        if (itm?.message?.options?.tabId === options?.tabId) {
                            return {
                                ...itm,
                                message: {
                                    ...itm.message,
                                    options: {
                                        ...itm.message.options,
                                        style: value,
                                    },
                                },
                            };
                        }
                        return itm;
                    });
                    return {
                        ...item,
                        message: updatedMessage,
                    };
                }

                return item;
            });

            dispatch({
                type: CHANGE_CALENDAR,
                data: {
                    [conversationId]: {
                        ...tabStackData,
                        components: updatedComponents,
                    },
                },
            });
        }
    }
};


export const handleContainerTabChange = (conversationId, message, containerSelectedTabIndex) => (dispatch, getState) => {
    const tabStack = getState().tabStack;

    if (!isEmpty(tabStack)) {
        const tabStackData = tabStack[conversationId];

        if (!isEmpty(tabStackData) && !isEmpty(tabStackData.components)) {
            const updatedComponents = tabStackData.components.map(
                (item) => {
                    const itemTabId = item.options?.tabId;
                    const messageTabId = message.options?.tabId;

                    if (itemTabId === messageTabId) {
                        return {
                            ...item,
                            containerSelectedTabIndex: containerSelectedTabIndex || 0,
                        };
                    }
                    return item;
                }
            );

            const updatedTabStackData = {
                ...tabStackData,
                components: updatedComponents,
            };

            dispatch({
                type: CHANGE_CONTAINER_SELECTED_TAB,
                data: {
                    [conversationId]: updatedTabStackData,
                },
            });
        }
    }
};


export const resetContainerFields = (conversationId, message) => (dispatch, getState) => {
    if (getState().tabStack && !isEmpty(getState().tabStack)) {
        let tabStackData = cloneDeep(getState().tabStack[conversationId]);

        // search for the message
        for (let i = 0; i < tabStackData.components.length; i++) {
            if (
                tabStackData.components[i] &&
                tabStackData.components[i].options &&
                message?.options &&
                tabStackData.components[i].options.tabId ===
                message.options.tabId
            ) {
                for (
                    let j = 0;
                    j < tabStackData.components[i].message.length;
                    j++
                ) {
                    // check if it is form type
                    if (
                        tabStackData.components[i].message[j].type ===
                        MessageTypeConstants.MESSAGE_TYPE_FORM2
                    ) {
                        // reset for fields in forms
                        for (
                            let k = 0;
                            k <
                            tabStackData.components[i].message[j].message.fields
                                .length;
                            k++
                        ) {
                            if (
                                !tabStackData.components[i].message[j].message.fields[
                                    k
                                ].readOnly
                            ) {
                                tabStackData.components[i].message[j].message.fields[
                                    k
                                ].value = "";
                                if (
                                    tabStackData.components[i].message[j].message.fields[
                                        k
                                    ].results &&
                                    !isEmpty(
                                        tabStackData.components[i].message[j].message
                                            .fields[k].results
                                    )
                                ) {
                                    tabStackData.components[i].message[j].message.fields[
                                        k
                                    ].results = [];
                                }
                            }
                        }
                    }
                }
            }
        }

        dispatch({
            type: RESET_CONTAINER_FIELDS,
            data: {
                [conversationId]: tabStackData,
            },
        });
    }
};